export function getOrCreateId(ref: React.RefObject<string>) {
  if (!ref.current && typeof window !== 'undefined') {
    ref.current = crypto.randomUUID();
  }
  return ref.current;
}
